<!-- eslint-disable vue/attribute-hyphenation -->
<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">

          <!-- Table Header -->
          <div class="pb-0 card-header">
            <div class="d-lg-flex">
              <div>
                <h5 class="mb-0">{{ title }}</h5>
                <p class="mb-0 text-sm">{{ description }}</p>
              </div>
              <div class="my-auto mt-4 ms-auto mt-lg-0">
                <div class="my-auto ms-auto mt-2">
                  <FilterDate :value-date=filters.date @filter-change="onDateFilterChange" @clean-filter-date="onCleanFilterDate"/>
                  <Filter :filter-status-selected="filterStatusSelected" @filter-change="onFilterChange"/>
                  <soft-button class="btn-icon ms-2 export" size color="primary" variant="outline" data-type="csv" @click="onDownloadExcel">
                    <span class="btn-inner--icon">
                      <i class="fa-solid fa-file-download me-2"></i>
                    </span>
                    <span class="btn-inner--text">{{ $t('key_purchaseListTableHeader_button_export_purchase') }}</span>
                  </soft-button>
                  <!-- Interactions with database (filters and reload) -->
                  <ReloadButton :title="$t('key_purchaseListTableHeader_button_reload_purchase')" @change="getShipments"/>
                </div>
              </div>
              <div class="mt-4 mt-lg-0">
                <div class="my-auto ms-auto mt-2">
                  <!-- Search space -->
                  <Searchbox :list-filters="listFilters" @change="onSearchChange"/>
                </div>
              </div>
            </div>
          </div>

          <!-- Tabla con los Datos -->
          <GenericTable
            v-if="!!enviosData"
            ref="genericTable"
            :items="enviosData.items"
            :list-filters="listFilters"
            :pagination="pagination"
            :headers="headers"
            :is-loading="isLoading"
            @header-changed="onHeaderChange"
            @changed-page="paginationPageChange"
            @row-change="paginationRowChange">
            <template #row="envio">
              <td style="width: 5rem">
                <div class="d-flex align-items-center">
                  <a style="cursor:pointer" class="mx-3" :title="$t('key_purchaseList_viewFiles')" data-bs-toggle="modal" data-bs-target="#uploadFolder" @click="loadResource(envio)">
                    <i v-if="envio.with_resource && envio.with_resource == true" class="fa-solid fa-folder-plus text-warning"></i>
                    <i v-else class="fa-solid fa-folder-open text-warning"></i>
                  </a>
                  <FileModalSelector
                    data-bs-backdrop="static"
                    :resources='shipmentResource'
                    :entity-id='entityId'
                    :entity-number='entityNumber'
                    :errors='shipmentErrorResource'
                    :url='urlUploadResource'
                    @success-upload='uploadedResource'
                    @remove-item='removeResource'
                    @close-modal='getShipments'
                  />
                </div>
              </td>
              <td style="width: 20rem" class="text-xs cursor-pointer font-weight-bolder mb-0 picko-link">
                <div class="d-flex">
                  <!-- <div class="my-auto form-check">
                    <input :id="item.id" class="form-check-input" type="checkbox" :checked="selectedIds.includes(item.id)" @change="changedSelection(item.id)" >
                  </div> -->
                  <a class="my-auto ms-3 picko">
                    <a class="font-weight-bold text-primary" href="#" @click.prevent="goToDetalle(envio)">
                      {{ envio.number }}
                    </a>
                  </a>
                </div>
              </td>
              <!-- <td style="width: 20rem" class="text-sm font-weight-bold">
                <a class="cursor-pointer font-weight-bold font-weight-bold mb-0 picko-link" :title="$t('key_purchaseList_viewPurchase')" @click="goToDetalle(envio)">
                  {{envio.number}}
                </a>
              </td> -->
              <!-- <td class="font-weight-bold">
                <span class="my-2 text-xs columns">{{ envio.reference }}</span>
              </td> -->
              <td class="font-weight-bold">
                <span class="my-2 text-xs columns">{{ $dateUtils.toDDMMYYYY(envio.date) }}</span>
              </td>
              <td class="font-weight-bold">
                <span class="my-2 text-xs columns">{{ envio.courier }}</span>
              </td>
              <td class="font-weight-bold">
                <span class="my-2 text-xs columns">{{ envio.deliver.receiver.name }}</span>
              </td>
              <!-- <td class="font-weight-bold">
                <span v-if="envio.batch_control" class="badge badge-info badge-sm">{{ $t('key_purchaseList_batchControl') }}</span>
              </td>
              <td class="font-weight-bold">
                <span v-if="envio.batch_control_date" class="badge badge-info badge-sm">{{ $t('key_purchaseList_batchControlDate') }}</span>
              </td> -->
              <td class="font-weight-bold">
                <span v-if="envio.status == 'EN_PROCESO'" class="badge badge-waitingforpickup badge-sm">{{ $t('key_shipmentList_inProcess') }}</span>
                <span v-else class="badge badge-shipped badge-sm">{{ $t('key_shipmentList_finished') }}</span>
              </td>
              <td class="font-weight-bold">
                <span class="my-2 text-xs columns">{{ $dateUtils.toDDMMYYYYHH(envio.created_at) }}</span>
              </td>
            </template>
          </GenericTable>

        </div>
      </div>
    </div>
  </div>
  <div class="position-fixed top-8 end-2 z-index-2">
    <soft-snackbar
      v-if="showNotification"
      :title="notificationInfo.title"
      :description="notificationInfo.message"
      :icon="{ component: notificationInfo.status=='success'?'ni ni-check-bold':'ni ni-fat-remove' , color: notificationInfo.status=='success'?'success':'danger' }"
      :color="notificationInfo.status=='success'?'success':'danger'"
      @close-handler="showNotification = !showNotification"
    />
  </div>
</template>

<script>
  
  import GenericTable from "./../../picko_components/generic_components/GenericTable.vue";
  import ReloadButton from "./../../picko_components/generic_components/ReloadButton.vue";
  import Searchbox from "./../../picko_components/generic_components/Searchbox.vue";
  import SoftButton from "@/components/SoftButton.vue";
  import { FileModalSelector } from "@/hotaka/components";
  import Filter from "./components/Filter.vue";
  import SoftSnackbar from "@/components/SoftSnackbar.vue";
  import FilterDate from "../../components/FilterDate.vue";
  import Cookies from 'js-cookie';

  export default {
    name: "ShipmentList",
    components: {
      SoftButton,
      Filter,
      SoftSnackbar,
      FileModalSelector,
      FilterDate,
      GenericTable,
      ReloadButton,
      Searchbox
    },
    data() {
      return {
        filterStatusSelected: '',
        pagination: {
          total: 34,
          rows: 10,
          currentPage: 1,
          pages: {
            total: 10,
            current: 1
          },
          entries: [5, 10, 15, 20, 50]
        },
        isLoading: false,
        urlUploadResource: "shipment",
        entityId: null,
        entityNumber: null,
        filters:{
          search: '',
          status:'',
          sort:{
            sort:'',
            order:''
          },
          date: {
            start: '',
            end: ''
          }
        },
        showNotification: false,
      };
    },
    computed: {
      enviosData() {
        return this.$store.state.shipment.list.data;
      },
      shipmentsExcel() {
        return this.$store.state.shipment.shipmentsExcel.data;
      },
      shipmentResource() {
        return this.$store.state.shipment.shipmentResource.data;
      },
      shipmentErrorResource() {
        return this.$store.state.shipment.shipmentResource.error;
      },
      listFilters() {
        return this.$store.state.shipment.listFilters;
      },
      headers() {
        return [
          { title: this.$t('key_theader_ShipmentList_files'), sort: { sorteable: true, order: '' }, column: 'with_resource' },
          { title: this.$t('key_theader_ShipmentList_number'), sort: { sorteable: true, order: '' }, column: 'number' },
          /* { title: this.$t('key_theader_ShipmentList_reference'), sort: { sorteable: true, order: '' }, column: 'reference' }, */
          { title: this.$t('key_theader_ShipmentList_date'), sort: { sorteable: true, order: '' }, column: 'date' },
          { title: this.$t('key_theader_ShipmentList_courier'), sort: { sorteable: true, order: '' }, column: 'courier' },
          { title: this.$t('key_theader_ShipmentList_end_customer'), sort: { sorteable: true, order: '' }, column: 'end_customer' },
          /* { title: this.$t('key_theader_ShipmentList_batch_control'), sort: { sorteable: true, order: '' }, column: 'batch_control' },
          { title: this.$t('key_theader_ShipmentList_batch_control_date'), sort: { sorteable: true, order: '' }, column: 'batch_control_date' }, */
          { title: this.$t('key_theader_ShipmentList_status'), sort: { sorteable: true, order: '' }, column: 'status' },
          { title: this.$t('key_theader_ShipmentList_created_on'), sort: { sorteable: true, order: '' }, column: 'created_at' }
        ]
      },
      title() {
        return this.$t('key_shipmentList_table_title');
      },
      description() {
        return this.$t('key_shipmentList_table_description');
      }
    },
    watch: {
      enviosData() {
        if(this.enviosData){
          this.pagination.total= this.enviosData.total;
          this.isLoading = false;
        }
      },
      shipmentsExcel() {
        if (this.$store.state.shipment.shipmentsExcel.error) {
          const error = this.$store.state.shipment.shipmentsExcel.error;
          const fr = new FileReader();
          fr.onload = (e) => {
            let excelError = JSON.parse(e.target.result);
            this.notificationInfo={
              title: 'Ups! Error',
              message: excelError,
              status: 'error'
            }
            this.showNotification=true;
            this.closeNotification();
          };
          fr.readAsText(error);
        }
        else{
          this.downloadExcel(this.shipmentsExcel);
          return;
        }
      },

    },
    mounted() {
      this.setUpFilters()
      this.getShipments();
    },
    methods: {
      setUpFilters() {
        if (Object.keys(this.listFilters).length == 0) {
          this.defaultRangeDate()
          return
        }

        this.filters = { ...JSON.parse(JSON.stringify(this.listFilters['filters'])) }
        this.pagination = { ...JSON.parse(JSON.stringify(this.listFilters.pagination)) }
        this.headers = this.headers.map(header => {
          let newHeader = { ...header }

          if (this.filters.sort.sort == header.column) {
            newHeader.sort.order = this.filters.sort.order == 'descending' ? 'desc' : 'asc'
          }

          return newHeader
        })
      },
      defaultRangeDate(){
        const fecha = new Date();
    
        const from90 = new Date(
          fecha.getFullYear(),
          fecha.getMonth(),
          fecha.getDate()-90
        );
        const today= new Date(
          fecha.getFullYear(),
          fecha.getMonth(),
          fecha.getDate()
        );
        
        this.filters.date.start=this.$dateUtils.toFormat(from90, 'yyyy-MM-DD');
        this.filters.date.end= this.$dateUtils.toFormat(today,'yyyy-MM-DD');
      },
      uploadedResource(upload){
        if (upload['type'] == 'img') {
          this.$store.commit("shipment/appendImage", upload['entity']);
          return
        }
        this.$store.commit("shipment/appendDocument", upload['entity']);
      },
      removeResource(contract){
        if (contract['type'] == 'img') {
          this.$store.commit("shipment/removeImage", contract['entity']);
          return
        }
        this.$store.commit("shipment/removeDocument", contract['entity']);
      },
      loadResource(entity){
        this.entityId = entity._id
        this.entityNumber = entity.number
        this.$store.commit("shipment/resetResources");
        this.$store.commit("shipment/loadResource", entity._id);
      },
      onHeaderChange(val){
        this.filters.sort={
          sort: val.column,
          order: val.order=='asc'? "ascending": "descending"
        }
        this.getShipments(); 
      },
      getShipments(){
        if (this.isLoading) return;

        this.isLoading = true;
        this.$store.commit("shipment/load",{
          filters: this.filters,
          pagination: this.pagination
        });
      },
      paginationPageChange(page) {
        this.pagination.currentPage = page;
        this.getShipments(); 
      },
      paginationRowChange(rows) {
        this.pagination.rows = rows;
        this.getShipments(); 
      },
      headerChange(header){
        console.log(header);
      },
      goToDetalle(element){
        this.$router.push({ path: "/Operations/Shipments/ShipmentDetail/" + element._id});
      },
      printEtiqueta(){
      },
      onSearchChange(value){
        this.pagination.currentPage = 1;
        this.filters.search=value;
        this.getShipments();

      },
      onFilterChange(value){
        this.filterStatusSelected = value
        this.filters.status=value;
        this.getShipments();

      },
      onDateFilterChange(value){
        this.filters.date.start= value.start
        this.filters.date.end= value.end
        this.getShipments();
      },

      closeNotification(){
        const self= this;
        setTimeout(function () {
            self.showNotification=false
        },2700);
      },
      onDownloadExcel() {
        let savedLanguage = Cookies.get('Picko.language') || 'en';
        this.$store.commit("shipment/shipmentsExcel", {filters: this.filters, language: savedLanguage});
      },
      downloadExcel(blob) {
        const link = document.createElement("a");
        const currentDate = new Date();
        const formattedDate = currentDate.toISOString().split('T')[0];
        link.setAttribute('download', `Shipments-${formattedDate}`);
        link.href = URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setTimeout(() => {
            URL.revokeObjectURL(link.href);
        }, 100);
      },
      onCleanFilterDate(){
        this.defaultRangeDate();
        this.getShipments();
      }    
    },
  };

</script>

<style scoped>
  
  .columns {
    max-width: 150px;
  }

</style>